module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.compare !== '0.00') ? _c('i', {
    staticClass: "percents",
    class: {
      positive: _vm.total >= 0,
        negative: _vm.total === -1
    }
  }, [(_vm.total !== 0) ? _c('icon', {
    attrs: {
      "name": _vm.name
    }
  }) : _vm._e(), _vm._v(" "), (_vm.total !== 0) ? [_vm._v(_vm._s(_vm._f("percentage")(_vm.percent)))] : [_vm._v("0%")]], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6819a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Percents.vue
// module id = 546
// module chunks = 225